import clsx from 'clsx';
import React from 'react';

interface FeatureClusterProps {
  description: string;
  className?: string;
  imageElement: React.ReactNode;
  smallText?: string;
  title: string;
}

const FeatureCluster = ({
  className,
  description,
  imageElement,
  smallText,
  title,
}: FeatureClusterProps) => {
  return (
    <section className={clsx('flex w-full flex-col items-start', className)}>
      <header className="flex-start flex flex-col gap-24">
        {imageElement}
        <h3 className="m-0 font-suisse-works text-headline-sm text-primary-black sm:text-headline-md">
          {title}
        </h3>
      </header>
      <p className="m-0 mt-24 font-suisse-neue text-body-lg text-primary-black">{description}</p>
      {smallText && (
        <p className="m-0 mt-24 font-suisse-intl-mono text-overline-md text-primary-black">
          {smallText}
        </p>
      )}
    </section>
  );
};

export default FeatureCluster;
